module.exports = __webpack_public_path__ + "img/ic_filter.077007ac.svg";